import { toast } from 'react-hot-toast'
import API from '../api'
import {
    PRODUCT_LIST_REQUEST,
    PRODUCT_LIST_SUCCESS,
    PRODUCT_LIST_FAIL,
    PRODUCT_DETAILS_REQUEST,
    PRODUCT_DETAILS_SUCCESS,
    PRODUCT_DETAILS_FAIL,
    PRODUCT_DELETE_REQUEST,
    PRODUCT_DELETE_SUCCESS,
    PRODUCT_DELETE_FAIL,
    PRODUCT_CREATE_REQUEST,
    PRODUCT_CREATE_FAIL,
    PRODUCT_CREATE_SUCCESS,
    //    PRODUCT_CREATE_RESET,
    PRODUCT_UPDATE_REQUEST,
    PRODUCT_UPDATE_FAIL,
    PRODUCT_UPDATE_SUCCESS,
    PRODUCT_CREATE_REVIEW_REQUEST,
    PRODUCT_CREATE_REVIEW_SUCCESS,
    PRODUCT_CREATE_REVIEW_FAIL,
    SHOW_DELETE_MODAL,
    HIDE_DELETE_MODAL,
    SHOW_CREATE_MODAL,
    HIDE_CREATE_MODAL,
    HIDE_UPDATE_MODAL,
    SHOW_UPDATE_MODAL,
    PRODUCTS_ALL_REQUEST,
    PRODUCTS_ALL_SUCCESS,
    PRODUCTS_ALL_FAIL,
} from '../constants/productConstants'
export const listProducts = (query = {}) => async (dispatch) => {
    try {
        const { page, limit, name, price, description, category, stores, stock } = query

        const queryStringNotNulls = Object.entries({
            page,
            limit,
            name,
            price,
            description,
            category,
            stores,
            stock
        }).filter(([, value]) => value !== undefined).map(([key, value]) => `${key}=${value}`).join('&')

        dispatch({ type: PRODUCT_LIST_REQUEST })

        const { data } = await API.get(`/products${queryStringNotNulls ? `?${queryStringNotNulls}` : ''}`)

        if (!data.ok || !data.products) throw new Error()



        dispatch({
            type: PRODUCT_LIST_SUCCESS,
            payload: data.products,
        })
    } catch (error) {
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }

}
export const ListproductbyCg = (Cg) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_LIST_REQUEST })
        const { data } = await API.get(`/products/?Cg=${Cg}`)
        dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message : error.message,
        })

    }

}

export const Listproductbyfiter = (filter) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_LIST_REQUEST })
        const { data } = await API.get(`/products/?filter=${filter}`)
        dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message : error.message,
        })

    }

}

export const Listproductbyprice = (from, to) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_LIST_REQUEST })
        const { data } = await API.get(`/products/?from=${from}&to=${to}`)
        dispatch({ type: PRODUCT_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({
            type: PRODUCT_LIST_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message : error.message,
        })

    }

}
export const listProductDetails = (id) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCT_DETAILS_REQUEST })

        const { data } = await API.get(`/products/${id}`)

        dispatch({
            type: PRODUCT_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        dispatch({
            type: PRODUCT_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })
    }

}


export const showDeleteProductModal = (item) => async (dispatch) => {
    dispatch({
        type: SHOW_DELETE_MODAL,
        payload: item
    })
}

export const showModalCreate = () => async (dispatch) => {
    dispatch({
        type: SHOW_CREATE_MODAL,
    })
}

export const hideModalCreate = () => async (dispatch) => {
    dispatch({
        type: HIDE_CREATE_MODAL,
    })
}

export const hideDeleteProductModal = () => async (dispatch) => {
    dispatch({
        type: HIDE_DELETE_MODAL,
    })
}

export const DeleteProduct = (id) => async (dispatch, getState) => {

    try {
        dispatch({
            type: PRODUCT_DELETE_REQUEST
        })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await API.delete(`/products?productId=${id}`, config)

        if (!data.ok) throw new Error()

        toast.success('Producto eliminado', {
            icon: '👍',
            style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
            },
        })

        dispatch({
            type: PRODUCT_DELETE_SUCCESS,
        })
    } catch (error) {


        console.log(error)

        toast.error('Error al eliminar el producto', {
            icon: '👎',
            style: {
                borderRadius: '10px',
                background: '#333',
                color: '#fff',
            },
        })

        dispatch({
            type: PRODUCT_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })

    }
}

export const CreateProduct = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: PRODUCT_CREATE_REQUEST
        })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await API.post(`/products/`, {}, config)
        dispatch({
            type: PRODUCT_CREATE_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: PRODUCT_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })

    }
}

export const showUpdateProductModal = (item) => async (dispatch) => {
    dispatch({
        type: SHOW_UPDATE_MODAL,
        payload: item
    })
}

export const hideUpdateProductModal = () => async (dispatch) => {
    dispatch({
        type: HIDE_UPDATE_MODAL,
    })
}

export const UpdateProduct = (product) => async (dispatch, getState) => {
    console.log(product)

    try {
        dispatch({
            type: PRODUCT_UPDATE_REQUEST
        })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        const { data } = await API.put(`/products/${product._id}`, product, config)
        dispatch({
            type: PRODUCT_UPDATE_SUCCESS,
            payload: data
        })



    } catch (error) {
        dispatch({
            type: PRODUCT_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })

    }
}
export const createproductReview = (productId, review) => async (dispatch, getState) => {

    try {
        dispatch({
            type: PRODUCT_CREATE_REVIEW_REQUEST
        })

        const { userLogin: { userInfo } } = getState()

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        }

        await API.post(`/products/${productId}/reviews`, review, config)
        dispatch({
            type: PRODUCT_CREATE_REVIEW_SUCCESS,
        })



    } catch (error) {
        dispatch({
            type: PRODUCT_CREATE_REVIEW_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        })

    }
}

export const getProductsAll = ({ page = 1, limit = 10, searchTerm }) => async (dispatch) => {
    try {
        dispatch({ type: PRODUCTS_ALL_REQUEST })

        const query = buildQuery({ page, limit, name: searchTerm })
        const { data } = await API.get('/products/all' + query)

        dispatch({
            type: PRODUCTS_ALL_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: PRODUCTS_ALL_FAIL,
            payload: error.response && error.response.data.message
                ? error.response.data.message
                : error.message,
        })
    }
}

const buildQuery = (params) => {
    let query = '?'
    for (const key in params) {
        if (params[key]) {
            query += `${key}=${params[key]}&`
        }
    }
    return query
}